import React, { useContext } from 'react';
import PropTypes from 'prop-types';
import { NuDsContext } from '@nubank/nuds-web/components/NuDSProvider/NuDSProvider';
import Box from '@nubank/nuds-web/components/Box/Box';
import Typography from '@nubank/nuds-web/components/Typography/Typography';
import Image from '@nubank/nuds-web/components/Image/Image';

function SectionDebit({ index }) {
  const { formatMessage } = useContext(NuDsContext);
  return (
    <Box
      tag="section"
      id="debito"
      paddingBottom={{ xs: '2x', md: '20x', lg: '24x' }}
    >
      <Box>
        <Image
          altIntlKey="ACCOUNT.DEBIT.IMAGE_ALT"
          loading="lazy"
          srcSet={{
            xs: {
              '1x': 'cartao-proximo-ao-olho/cartao-proximo-ao-olho-xs@1x.jpg',
              '2x': 'cartao-proximo-ao-olho/cartao-proximo-ao-olho-xs@2x.jpg',
              '3x': 'cartao-proximo-ao-olho/cartao-proximo-ao-olho-xs@3x.jpg',
            },
            md: {
              '1x': 'cartao-proximo-ao-olho/cartao-proximo-ao-olho-md@1x.jpg',
              '2x': 'cartao-proximo-ao-olho/cartao-proximo-ao-olho-md@2x.jpg',
              '3x': 'cartao-proximo-ao-olho/cartao-proximo-ao-olho-md@3x.jpg',
            },
            lg: {
              '1x': 'cartao-proximo-ao-olho/cartao-proximo-ao-olho-lg@1x.jpg',
              '2x': 'cartao-proximo-ao-olho/cartao-proximo-ao-olho-lg@2x.jpg',
              '3x': 'cartao-proximo-ao-olho/cartao-proximo-ao-olho-lg@3x.jpg',
            },
          }}
        />
      </Box>
      <Box paddingHorizontal={{ xs: '6x', md: '12x', lg: 56 }} marginTop={{ xs: '8x', md: '12x' }}>
        <Typography
          variant="title"
          intlKey={`cms.accountPage.cardsArea[${index}].title`}
          marginBottom={{ xs: '4x' }}
          marginHorizontal={{ md: 'auto' }}
          maxWidth={{ md: '32rem', lg: 'none' }}
          textAlign={{ md: 'center' }}
        />
        <Typography
          variant="subtitle"
          intlKey={`cms.accountPage.cardsArea[${index}].subtitle`}
          marginHorizontal={{ md: 'auto' }}
          marginBottom={{ xs: '16x', md: '12x' }}
          maxWidth={{ md: '30rem', lg: 'none' }}
          textAlign={{ md: 'center' }}
        />
        <Box
          display={{ md: 'grid' }}
          gridTemplateColumns={{ md: 'repeat(6,1fr)', lg: 'repeat(12,1fr)' }}
          gridTemplateRows={{ md: '1fr auto' }}
          gridColumnGap={{ md: '8x' }}
        >
          <Box
            gridColumn={{ md: '1 / 4', lg: '2 / 7' }}
            marginBottom={{ xs: '8x', md: '0x' }}
          >
            <Typography
              variant="subtitle"
              intlKey={`cms.accountPage.cardsArea[${index}].firstBlockTitle`}
              marginBottom={{ xs: '4x' }}
            />
            {formatMessage({
              id: `cms.accountPage.cardsArea[${index}].firstBlockDescription`,
            }, {
              strong: props => <Typography tag="strong" variant="paragraph2" {...props} />,
              p: props => <Typography variant="paragraph1" marginBottom="5x" {...props} />,
            })}
          </Box>

          <Box
            gridColumn={{ md: '4 / 7', lg: '7 / 12' }}
            marginBottom={{ xs: '8x', md: '0x' }}
          >
            <Typography
              variant="subtitle"
              intlKey={`cms.accountPage.cardsArea[${index}].secondBlockTitle`}
              marginBottom={{ xs: '4x' }}
            />
            {formatMessage({
              id: `cms.accountPage.cardsArea[${index}].secondBlockDescription`,
            }, {
              strong: props => <Typography tag="strong" variant="paragraph2" {...props} />,
              p: props => <Typography variant="paragraph1" marginBottom="5x" {...props} />,
            })}
          </Box>
        </Box>
      </Box>
    </Box>
  );
}

SectionDebit.propTypes = {
  index: PropTypes.number.isRequired,
};

export default React.memo(SectionDebit);
